import React from "react";
import PublicLayout from "../components/layout/PublicLayout";
import { usePages } from "../hooks/usePages";
import Skeleton from "../components/ui/Skeleton";
import { marked } from "marked";
import { useQuery } from "@tanstack/react-query";
import { useResolvedPath } from "react-router-dom";
import moment from "moment";

function PrivacyPolicy() {
  const { fetchPageById } = usePages();
  const path = useResolvedPath();
  const pageId = path.pathname.replace(/^\//, "");

  const { data, error, isLoading } = useQuery({
    queryKey: ["page", pageId],
    queryFn: () => fetchPageById(pageId),
  });

  const pages = data?.data ? [data.data] : [];

  return (
    <PublicLayout>
      <div className="max-w-4xl min-w-[90%] wrap-anywhere whitespace-normal break-all text-justify mx-auto p-6 bg-white border border-gray-300 rounded-lg shadow-md overflow-y-auto">
        <div className="prose max-w-none p-5">
          {isLoading && <Skeleton count={3} />}
          {error && <p className="text-red-600">Failed to load pages</p>}
          {!isLoading && !error && pages.length === 0 && <p>No pages found.</p>}
          {!isLoading && !error && pages.length > 0 && (
            <ul>
              {pages.map((page) => (
                <li key={page._id}>
                  <p className="text-center uppercase underline decoration-[14px] underline-offset-8 font-bold text-2xl mb-6">
                    {page.title}
                  </p>
                  {page.contents && page.contents.length > 0 ? (
                    <ul>
                      {page.contents.map((contentItem, index) => (
                        <li key={index} style={{ marginBottom: "1.5rem" }}>
                          <p className="text-left font-semibold text-lg mb-4">
                            Last Updated{" "}
                            {contentItem?.updated_at
                              ? moment(contentItem?.updated_at).format(
                                  "MMMM DD, YYYY"
                                )
                              : ""}
                          </p>
                          <div
                            className="ck-content"
                            dangerouslySetInnerHTML={{
                              __html: marked.parse(contentItem.description),
                            }}
                          />
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No contents available.</p>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </PublicLayout>
  );
}

export default PrivacyPolicy;
